{
  "version": 1,
  "asset_id": "e114175d-8044-4948-b8f5-9f90a07fc7e6",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e114175d-8044-4948-b8f5-9f90a07fc7e6/loc-fort-worth-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e114175d-8044-4948-b8f5-9f90a07fc7e6/loc-fort-worth-640.webp",
  "original_filename": "loc-fort-worth-640.webp",
  "size": 25866,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:24Z"
}
